export const STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DC', label: 'District Of Columbia' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'GU', label: 'Guam' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'VI', label: 'U.S. Virgin Islands' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' }
];

export const countries = ['United States', 'Canada', 'United Kingdom'];

export const usStates = [
  { abbr: 'AL', name: 'Alabama' },
  { abbr: 'AK', name: 'Alaska' },
  { abbr: 'AZ', name: 'Arizona' },
  { abbr: 'AR', name: 'Arkansas' },
  { abbr: 'AS', name: 'American Samoa' },
  { abbr: 'CA', name: 'California' },
  { abbr: 'CO', name: 'Colorado' },
  { abbr: 'CT', name: 'Connecticut' },
  { abbr: 'DC', name: 'District Of Columbia' },
  { abbr: 'DE', name: 'Delaware' },
  { abbr: 'FL', name: 'Florida' },
  { abbr: 'GA', name: 'Georgia' },
  { abbr: 'GU', name: 'Guam' },
  { abbr: 'HI', name: 'Hawaii' },
  { abbr: 'ID', name: 'Idaho' },
  { abbr: 'IL', name: 'Illinois' },
  { abbr: 'IN', name: 'Indiana' },
  { abbr: 'IA', name: 'Iowa' },
  { abbr: 'KS', name: 'Kansas' },
  { abbr: 'KY', name: 'Kentucky' },
  { abbr: 'LA', name: 'Louisiana' },
  { abbr: 'ME', name: 'Maine' },
  { abbr: 'MD', name: 'Maryland' },
  { abbr: 'MA', name: 'Massachusetts' },
  { abbr: 'MI', name: 'Michigan' },
  { abbr: 'MN', name: 'Minnesota' },
  { abbr: 'MS', name: 'Mississippi' },
  { abbr: 'MO', name: 'Missouri' },
  { abbr: 'MT', name: 'Montana' },
  { abbr: 'NE', name: 'Nebraska' },
  { abbr: 'NV', name: 'Nevada' },
  { abbr: 'NH', name: 'New Hampshire' },
  { abbr: 'NJ', name: 'New Jersey' },
  { abbr: 'NM', name: 'New Mexico' },
  { abbr: 'NY', name: 'New York' },
  { abbr: 'NC', name: 'North Carolina' },
  { abbr: 'ND', name: 'North Dakota' },
  { abbr: 'OH', name: 'Ohio' },
  { abbr: 'OK', name: 'Oklahoma' },
  { abbr: 'OR', name: 'Oregon' },
  { abbr: 'PA', name: 'Pennsylvania' },
  { abbr: 'PR', name: 'Puerto Rico' },
  { abbr: 'RI', name: 'Rhode Island' },
  { abbr: 'SC', name: 'South Carolina' },
  { abbr: 'SD', name: 'South Dakota' },
  { abbr: 'TN', name: 'Tennessee' },
  { abbr: 'TX', name: 'Texas' },
  { abbr: 'UT', name: 'Utah' },
  { abbr: 'VT', name: 'Vermont' },
  { abbr: 'VA', name: 'Virginia' },
  { abbr: 'VI', name: 'U.S. Virgin Islands' },
  { abbr: 'WA', name: 'Washington' },
  { abbr: 'WV', name: 'West Virginia' },
  { abbr: 'WI', name: 'Wisconsin' },
  { abbr: 'WY', name: 'Wyoming' }
];

export const canadaStates = [
  { abbr: 'AB', name: 'Alberta' },
  { abbr: 'BC', name: 'British Columbia' },
  { abbr: 'MB', name: 'Manitoba' },
  { abbr: 'NB', name: 'New Brunswick' },
  { abbr: 'NL', name: 'Newfoundland and Labrador' },
  { abbr: 'NS', name: 'Nova Scotia' },
  { abbr: 'NT', name: 'Northwest Territories' },
  { abbr: 'NU', name: 'Nunavut' },
  { abbr: 'ON', name: 'Ontario' },
  { abbr: 'PE', name: 'Prince Edward Island' },
  { abbr: 'QC', name: 'Quebec' },
  { abbr: 'SK', name: 'Saskatchewan' },
  { abbr: 'YT', name: 'Yukon' }
];

export const ukStates = [
  { abbr: 'ABD', name: 'Aberdeenshire' },
  { abbr: 'AGY', name: 'Anglesey' },
  { abbr: 'ANS', name: 'Angus' },
  { abbr: 'ANT', name: 'Antrim' },
  { abbr: 'ARL', name: 'Argyllshire' },
  { abbr: 'ARM', name: 'Armagh' },
  { abbr: 'AVN', name: 'Avon' },
  { abbr: 'AYR', name: 'Ayrshire' },
  { abbr: 'BAN', name: 'Banffshire' },
  { abbr: 'BDF', name: 'Bedfordshire' },
  { abbr: 'BEW', name: 'Berwickshire' },
  { abbr: 'BKM', name: 'Buckinghamshire' },
  { abbr: 'BOR', name: 'Borders' },
  { abbr: 'BRE', name: 'Breconshire' },
  { abbr: 'BRK', name: 'Berkshire' },
  { abbr: 'BUT', name: 'Bute' },
  { abbr: 'CAE', name: 'Caernarvonshire' },
  { abbr: 'CAI', name: 'Caithness' },
  { abbr: 'CAM', name: 'Cambridgeshire' },
  { abbr: 'CEN', name: 'Central' },
  { abbr: 'CGN', name: 'Cardiganshire' },
  { abbr: 'CHS', name: 'Cheshire' },
  { abbr: 'CLK', name: 'Clackmannanshire' },
  { abbr: 'CLV', name: 'Cleveland' },
  { abbr: 'CMA', name: 'Cumbria' },
  { abbr: 'CMN', name: 'Carmarthenshire' },
  { abbr: 'CON', name: 'Cornwall' },
  { abbr: 'CUL', name: 'Cumberland' },
  { abbr: 'CWD', name: 'Clwyd' },
  { abbr: 'DBY', name: 'Derbyshire' },
  { abbr: 'DEN', name: 'Denbighshire' },
  { abbr: 'DEV', name: 'Devon' },
  { abbr: 'DFD', name: 'Dyfed' },
  { abbr: 'DFS', name: 'Dumfries-shire' },
  { abbr: 'DGY', name: 'Dumfries and Galloway' },
  { abbr: 'DNB', name: 'Dunbartonshire' },
  { abbr: 'DOR', name: 'Dorset' },
  { abbr: 'DOW', name: 'Down' },
  { abbr: 'DUR', name: 'Durham' },
  { abbr: 'ELN', name: 'East Lothian' },
  { abbr: 'ERY', name: 'East Riding of Yorkshire' },
  { abbr: 'ESS', name: 'Essex' },
  { abbr: 'FER', name: 'Fermanagh' },
  { abbr: 'FIF', name: 'Fife' },
  { abbr: 'FLN', name: 'Flintshire' },
  { abbr: 'GLA', name: 'Glamorgan' },
  { abbr: 'GLS', name: 'Gloucestershire' },
  { abbr: 'GMP', name: 'Grampian' },
  { abbr: 'GNT', name: 'Gwent' },
  { abbr: 'GTM', name: 'Greater Manchester' },
  { abbr: 'GWN', name: 'Gwynedd' },
  { abbr: 'HAM', name: 'Hampshire' },
  { abbr: 'HEF', name: 'Herefordshire' },
  { abbr: 'HLD', name: 'Highland' },
  { abbr: 'HRT', name: 'Hertfordshire' },
  { abbr: 'HUM', name: 'Humberside' },
  { abbr: 'HUN', name: 'Huntingdonshire' },
  { abbr: 'HWR', name: 'Hereford and Worcester' },
  { abbr: 'INV', name: 'Inverness-shire' },
  { abbr: 'IOW', name: 'Isle of Wight' },
  { abbr: 'KCD', name: 'Kincardineshire' },
  { abbr: 'KEN', name: 'Kent' },
  { abbr: 'KKD', name: 'Kirkcudbrightshire' },
  { abbr: 'KRS', name: 'Kinross-shire' },
  { abbr: 'LAN', name: 'Lancashire' },
  { abbr: 'LDY', name: 'Londonderry' },
  { abbr: 'LEI', name: 'Leicestershire' },
  { abbr: 'LIN', name: 'Lincolnshire' },
  { abbr: 'LKS', name: 'Lanarkshire' },
  { abbr: 'LTN', name: 'Lothian' },
  { abbr: 'MER', name: 'Merionethshire' },
  { abbr: 'MGM', name: 'Mid Glamorgan' },
  { abbr: 'MGY', name: 'Montgomeryshire' },
  { abbr: 'MLN', name: 'Midlothian' },
  { abbr: 'MON', name: 'Monmouthshire' },
  { abbr: 'MOR', name: 'Morayshire' },
  { abbr: 'MSY', name: 'Merseyside' },
  { abbr: 'NAI', name: 'Nairn' },
  { abbr: 'NBL', name: 'Northumberland' },
  { abbr: 'NFK', name: 'Norfolk' },
  { abbr: 'NRY', name: 'North Riding of Yorkshire' },
  { abbr: 'NTH', name: 'Northamptonshire' },
  { abbr: 'NTT', name: 'Nottinghamshire' },
  { abbr: 'NYK', name: 'North Yorkshire' },
  { abbr: 'OKI', name: 'Orkney' },
  { abbr: 'OXF', name: 'Oxfordshire' },
  { abbr: 'PEE', name: 'Peebles-shire' },
  { abbr: 'PEM', name: 'Pembrokeshire' },
  { abbr: 'PER', name: 'Perth' },
  { abbr: 'POW', name: 'Powys' },
  { abbr: 'RAD', name: 'Radnorshire' },
  { abbr: 'RFW', name: 'Renfrewshire' },
  { abbr: 'ROC', name: 'Ross and Cromarty' },
  { abbr: 'ROX', name: 'Roxburghshire' },
  { abbr: 'RUT', name: 'Rutland' },
  { abbr: 'SAL', name: 'Shropshire' },
  { abbr: 'SEL', name: 'Selkirkshire' },
  { abbr: 'SFK', name: 'Suffolk' },
  { abbr: 'SGM', name: 'South Glamorgan' },
  { abbr: 'SHI', name: 'Shetland' },
  { abbr: 'SOM', name: 'Somerset' },
  { abbr: 'SRY', name: 'Surrey' },
  { abbr: 'SSX', name: 'Sussex' },
  { abbr: 'STD', name: 'Strathclyde' },
  { abbr: 'STI', name: 'Stirlingshire' },
  { abbr: 'STS', name: 'Staffordshire' },
  { abbr: 'SUT', name: 'Sutherland' },
  { abbr: 'SXE', name: 'East Sussex' },
  { abbr: 'SXW', name: 'West Sussex' },
  { abbr: 'SYK', name: 'South Yorkshire' },
  { abbr: 'TAY', name: 'Tayside' },
  { abbr: 'TWR', name: 'Tyne and Wear' },
  { abbr: 'TYR', name: 'Tyrone' },
  { abbr: 'WAR', name: 'Warwickshire' },
  { abbr: 'WES', name: 'Westmorland' },
  { abbr: 'WGM', name: 'West Glamorgan' },
  { abbr: 'WIG', name: 'Wigtownshire' },
  { abbr: 'WIL', name: 'Wiltshire' },
  { abbr: 'WIS', name: 'Western Isles' },
  { abbr: 'WLN', name: 'West Lothian' },
  { abbr: 'WMD', name: 'West Midlands' },
  { abbr: 'WOR', name: 'Worcestershire' },
  { abbr: 'WRY', name: 'West Riding of Yorkshire' },
  { abbr: 'WYK', name: 'West Yorkshire' },
  { abbr: 'YKS', name: 'Yorkshire' }
];

export const states = {
  'United States': usStates,
  Canada: canadaStates,
  'United Kingdom': ukStates
};

export const stateNames = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  AS: 'American Samoa',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'District Of Columbia',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  VI: 'U.S. Virgin Islands',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
  AB: 'Alberta',
  BC: 'British Columbia',
  MB: 'Manitoba',
  NB: 'New Brunswick',
  NL: 'Newfoundland and Labrador',
  NS: 'Nova Scotia',
  NT: 'Northwest Territories',
  NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Prince Edward Island',
  QC: 'Quebec',
  SK: 'Saskatchewan',
  YT: 'Yukon',
  ABD: 'Aberdeenshire',
  AGY: 'Anglesey',
  ANS: 'Angus',
  ANT: 'Antrim',
  ARL: 'Argyllshire',
  ARM: 'Armagh',
  AVN: 'Avon',
  AYR: 'Ayrshire',
  BAN: 'Banffshire',
  BDF: 'Bedfordshire',
  BEW: 'Berwickshire',
  BKM: 'Buckinghamshire',
  BOR: 'Borders',
  BRE: 'Breconshire',
  BRK: 'Berkshire',
  BUT: 'Bute',
  CAE: 'Caernarvonshire',
  CAI: 'Caithness',
  CAM: 'Cambridgeshire',
  CEN: 'Central',
  CGN: 'Cardiganshire',
  CHS: 'Cheshire',
  CLK: 'Clackmannanshire',
  CLV: 'Cleveland',
  CMA: 'Cumbria',
  CMN: 'Carmarthenshire',
  CON: 'Cornwall',
  CUL: 'Cumberland',
  CWD: 'Clwyd',
  DBY: 'Derbyshire',
  DEN: 'Denbighshire',
  DEV: 'Devon',
  DFD: 'Dyfed',
  DFS: 'Dumfries-shire',
  DGY: 'Dumfries and Galloway',
  DNB: 'Dunbartonshire',
  DOR: 'Dorset',
  DOW: 'Down',
  DUR: 'Durham',
  ELN: 'East Lothian',
  ERY: 'East Riding of Yorkshire',
  ESS: 'Essex',
  FER: 'Fermanagh',
  FIF: 'Fife',
  FLN: 'Flintshire',
  GLA: 'Glamorgan',
  GLS: 'Gloucestershire',
  GMP: 'Grampian',
  GNT: 'Gwent',
  GTM: 'Greater Manchester',
  GWN: 'Gwynedd',
  HAM: 'Hampshire',
  HEF: 'Herefordshire',
  HLD: 'Highland',
  HRT: 'Hertfordshire',
  HUM: 'Humberside',
  HUN: 'Huntingdonshire',
  HWR: 'Hereford and Worcester',
  INV: 'Inverness-shire',
  IOW: 'Isle of Wight',
  KCD: 'Kincardineshire',
  KEN: 'Kent',
  KKD: 'Kirkcudbrightshire',
  KRS: 'Kinross-shire',
  LAN: 'Lancashire',
  LDY: 'Londonderry',
  LEI: 'Leicestershire',
  LIN: 'Lincolnshire',
  LKS: 'Lanarkshire',
  LTN: 'Lothian',
  MER: 'Merionethshire',
  MGM: 'Mid Glamorgan',
  MGY: 'Montgomeryshire',
  MLN: 'Midlothian',
  MON: 'Monmouthshire',
  MOR: 'Morayshire',
  MSY: 'Merseyside',
  NAI: 'Nairn',
  NBL: 'Northumberland',
  NFK: 'Norfolk',
  NRY: 'North Riding of Yorkshire',
  NTH: 'Northamptonshire',
  NTT: 'Nottinghamshire',
  NYK: 'North Yorkshire',
  OKI: 'Orkney',
  OXF: 'Oxfordshire',
  PEE: 'Peebles-shire',
  PEM: 'Pembrokeshire',
  PER: 'Perth',
  POW: 'Powys',
  RAD: 'Radnorshire',
  RFW: 'Renfrewshire',
  ROC: 'Ross and Cromarty',
  ROX: 'Roxburghshire',
  RUT: 'Rutland',
  SAL: 'Shropshire',
  SEL: 'Selkirkshire',
  SFK: 'Suffolk',
  SGM: 'South Glamorgan',
  SHI: 'Shetland',
  SOM: 'Somerset',
  SRY: 'Surrey',
  SSX: 'Sussex',
  STD: 'Strathclyde',
  STI: 'Stirlingshire',
  STS: 'Staffordshire',
  SUT: 'Sutherland',
  SXE: 'East Sussex',
  SXW: 'West Sussex',
  SYK: 'South Yorkshire',
  TAY: 'Tayside',
  TWR: 'Tyne and Wear',
  TYR: 'Tyrone',
  WAR: 'Warwickshire',
  WES: 'Westmorland',
  WGM: 'West Glamorgan',
  WIG: 'Wigtownshire',
  WIL: 'Wiltshire',
  WIS: 'Western Isles',
  WLN: 'West Lothian',
  WMD: 'West Midlands',
  WOR: 'Worcestershire',
  WRY: 'West Riding of Yorkshire',
  WYK: 'West Yorkshire',
  YKS: 'Yorkshire'
};

export const stateAbbr = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  'American Samoa': 'AS',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  'District Of Columbia': 'DC',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Guam: 'GU',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Puerto Rico': 'PR',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  'U.S. Virgin Islands': 'VI',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
  Alberta: 'AB',
  'British Columbia': 'BC',
  Manitoba: 'MB',
  'New Brunswick': 'NB',
  'Newfoundland and Labrador': 'NL',
  'Nova Scotia': 'NS',
  'Northwest Territories': 'NT',
  Nunavut: 'NU',
  Ontario: 'ON',
  'Prince Edward Island': 'PE',
  Quebec: 'QC',
  Saskatchewan: 'SK',
  Yukon: 'YT',
  Aberdeenshire: 'ABD',
  Anglesey: 'AGY',
  Angus: 'ANS',
  Antrim: 'ANT',
  Argyllshire: 'ARL',
  Armagh: 'ARM',
  Avon: 'AVN',
  Ayrshire: 'AYR',
  Banffshire: 'BAN',
  Bedfordshire: 'BDF',
  Berwickshire: 'BEW',
  Buckinghamshire: 'BKM',
  Borders: 'BOR',
  Breconshire: 'BRE',
  Berkshire: 'BRK',
  Bute: 'BUT',
  Caernarvonshire: 'CAE',
  Caithness: 'CAI',
  Cambridgeshire: 'CAM',
  Central: 'CEN',
  Cardiganshire: 'CGN',
  Cheshire: 'CHS',
  Clackmannanshire: 'CLK',
  Cleveland: 'CLV',
  Cumbria: 'CMA',
  Carmarthenshire: 'CMN',
  Cornwall: 'CON',
  Cumberland: 'CUL',
  Clwyd: 'CWD',
  Derbyshire: 'DBY',
  Denbighshire: 'DEN',
  Devon: 'DEV',
  Dyfed: 'DFD',
  'Dumfries-shire': 'DFS',
  'Dumfries and Galloway': 'DGY',
  Dunbartonshire: 'DNB',
  Dorset: 'DOR',
  Down: 'DOW',
  Durham: 'DUR',
  'East Lothian': 'ELN',
  'East Riding of Yorkshire': 'ERY',
  Essex: 'ESS',
  Fermanagh: 'FER',
  Fife: 'FIF',
  Flintshire: 'FLN',
  Glamorgan: 'GLA',
  Gloucestershire: 'GLS',
  Grampian: 'GMP',
  Gwent: 'GNT',
  'Greater Manchester': 'GTM',
  Gwynedd: 'GWN',
  Hampshire: 'HAM',
  Herefordshire: 'HEF',
  Highland: 'HLD',
  Hertfordshire: 'HRT',
  Humberside: 'HUM',
  Huntingdonshire: 'HUN',
  'Hereford and Worcester': 'HWR',
  'Inverness-shire': 'INV',
  'Isle of Wight': 'IOW',
  Kincardineshire: 'KCD',
  Kent: 'KEN',
  Kirkcudbrightshire: 'KKD',
  'Kinross-shire': 'KRS',
  Lancashire: 'LAN',
  Londonderry: 'LDY',
  Leicestershire: 'LEI',
  Lincolnshire: 'LIN',
  Lanarkshire: 'LKS',
  Lothian: 'LTN',
  Merionethshire: 'MER',
  'Mid Glamorgan': 'MGM',
  Montgomeryshire: 'MGY',
  Midlothian: 'MLN',
  Monmouthshire: 'MON',
  Morayshire: 'MOR',
  Merseyside: 'MSY',
  Nairn: 'NAI',
  Northumberland: 'NBL',
  Norfolk: 'NFK',
  'North Riding of Yorkshire': 'NRY',
  Northamptonshire: 'NTH',
  Nottinghamshire: 'NTT',
  'North Yorkshire': 'NYK',
  Orkney: 'OKI',
  Oxfordshire: 'OXF',
  'Peebles-shire': 'PEE',
  Pembrokeshire: 'PEM',
  Perth: 'PER',
  Powys: 'POW',
  Radnorshire: 'RAD',
  Renfrewshire: 'RFW',
  'Ross and Cromarty': 'ROC',
  Roxburghshire: 'ROX',
  Rutland: 'RUT',
  Shropshire: 'SAL',
  Selkirkshire: 'SEL',
  Suffolk: 'SFK',
  'South Glamorgan': 'SGM',
  Shetland: 'SHI',
  Somerset: 'SOM',
  Surrey: 'SRY',
  Sussex: 'SSX',
  Strathclyde: 'STD',
  Stirlingshire: 'STI',
  Staffordshire: 'STS',
  Sutherland: 'SUT',
  'East Sussex': 'SXE',
  'West Sussex': 'SXW',
  'South Yorkshire': 'SYK',
  Tayside: 'TAY',
  'Tyne and Wear': 'TWR',
  Tyrone: 'TYR',
  Warwickshire: 'WAR',
  Westmorland: 'WES',
  'West Glamorgan': 'WGM',
  Wigtownshire: 'WIG',
  Wiltshire: 'WIL',
  'Western Isles': 'WIS',
  'West Lothian': 'WLN',
  'West Midlands': 'WMD',
  Worcestershire: 'WOR',
  'West Riding of Yorkshire': 'WRY',
  'West Yorkshire': 'WYK',
  Yorkshire: 'YKS'
};

export const usStatePaths = [
  'alabama',
  'alaska',
  'arizona',
  'arkansas',
  'american-samoa',
  'california',
  'colorado',
  'connecticut',
  'district-of-columbia',
  'delaware',
  'florida',
  'georgia',
  'guam',
  'hawaii',
  'idaho',
  'illinois',
  'indiana',
  'iowa',
  'kansas',
  'kentucky',
  'louisiana',
  'maine',
  'maryland',
  'massachusetts',
  'michigan',
  'minnesota',
  'mississippi',
  'missouri',
  'montana',
  'nebraska',
  'nevada',
  'new-hampshire',
  'new-jersey',
  'new-mexico',
  'new-york',
  'north-carolina',
  'north-dakota',
  'ohio',
  'oklahoma',
  'oregon',
  'pennsylvania',
  'puerto-rico',
  'rhode-island',
  'south-carolina',
  'south-dakota',
  'tennessee',
  'texas',
  'utah',
  'vermont',
  'virginia',
  'us-virgin-islands',
  'washington',
  'west-virginia',
  'wisconsin',
  'wyoming'
];

export const caStatePaths = [
  'alberta',
  'british-columbia',
  'manitoba',
  'new-brunswick',
  'newfoundland-and-labrador',
  'nova-scotia',
  'northwest-territories',
  'nunavut',
  'ontario',
  'prince-edward-island',
  'quebec',
  'saskatchewan',
  'yukon'
];
